import { v4 as randomUUID } from "uuid";
import {
  sdkIdentityFromPackage,
  type HighnoteEnvironment,
} from "@highnoteplatform/types";

import { name, version } from "../package.json";

const { SECURE_INPUTS_IFRAME_PORT = 3006 } = process.env;

const identity = sdkIdentityFromPackage({ name, version });
export const packageName: string = identity.name;
export const packageVersion: string = identity.version;

export const iframeOrigin =
  process.env.NODE_ENV === "production"
    ? "https://cdn.highnote.com"
    : `http://localhost:${SECURE_INPUTS_IFRAME_PORT}`;

// NOTE: the production iframe bundle is fetched from a fixed CDN path segment
// ("secure-inputs") that MUST match the deploy pipeline's hardcoded app name
// (publish-release.yml `matrix.app`) — keep it a literal, never derived, so a
// package.json rename can't point the fetch at an undeployed path. The version
// segment keys the bundle to THIS package's version: a release that changes
// secure-inputs-iframes without bumping @highnoteplatform/secure-inputs would
// overwrite an already-deployed bundle in place — always version them together.
// The telemetry sdkName (handshake.ts) IS derived from the package name via
// packageName; handshake.test.ts asserts sdkName === "secure-inputs", which pins
// packageName to this same literal so the telemetry label and CDN segment
// cannot silently desync.
const iframePath = (apiEnvironment: HighnoteEnvironment) => {
  let path = "";
  if (process.env.NODE_ENV === "production") {
    path = `secure-inputs/${packageVersion}/`;
  }

  return apiEnvironment === "test"
    ? `${path}index_test.html`
    : `${path}index.html`;
};

export const generateUuid = () => randomUUID();

export const iframeUri = (apiEnvironment: HighnoteEnvironment) =>
  `${iframeOrigin}/${iframePath(apiEnvironment)}`;
